import React, {PureComponent} from 'react';
import {FormInput} from '@homeaway/react-form-components';
import {FormattedMessage} from 'react-intl';
import {DebounceInput} from 'react-debounce-input';

import {validateEmail} from '../../../utils/validations';
import {EMAIL_LABEL} from '../../../utils/constants';

const EMAIL_LABEL_TEXT = (
    <FormattedMessage
        id="giftCardEmailAddressText"
        defaultMessage={EMAIL_LABEL}
    />
);

export default class EmailInput extends PureComponent {
    state = {
        isValid: true,
        errorMsg: ''
    };

    verify = (email) => {
        const invalidMailErrorMsg = validateEmail(email);
        if (invalidMailErrorMsg) {
            this.setState({errorMsg: invalidMailErrorMsg});
        }
    }

    handleFocus = () => {
        this.setState({errorMsg: ''});
    }

    handleBlur = (e) => {
        const email = e.target.value.trim();
        this.verify(email);
    }

    handleChange = (e) => {
        const email = e.target.value;
        this.props.input.onChange(email);
    }

    render() {
        const {errorMsg} = this.state;
        const {value} = this.props.input;
        const {error} = this.props.meta;
        const errorText = error || errorMsg;
        return (
            <DebounceInput
                debounceTimeout={300}
                element={FormInput}
                id="email"
                type="email"
                name="emailAddress"
                label={EMAIL_LABEL_TEXT}
                errorMsg = {errorText}
                value = {value}
                onBlur = {this.handleBlur}
                onChange={this.handleChange}
                onFocus = {this.handleFocus}
            />
        );
    }
}
